<div>
  <div class="header rounded-lg flex flex-row items-center top-0 asset-details z-50">
    <div class="title" i18n>TOP THEMES OF THE MONTHS</div>
    <div class="actions w-2/5 text-right">
      <button
        *ngIf="AnyGlobal | can: 'dashboard.editcollection'"
        mat-icon-button
        class="cursor-pointer"
        role="button"
        i18n-matTooltip
        matTooltip="Edit dashboard collections"
        (click)="editInformation()"
      >
        <mat-icon class="material-icons-outlined">edit</mat-icon>
      </button>
    </div>
  </div>
  <div class="public-collections">
    <div class="h-full pt-3">
      <div class="w-full h-[88%]">
        <!-- To show loading message, while http call is in progress -->
        <sp-loading-inprogress *ngIf="httpCallInProgress; else loadingComplete" [showSpinner]="true"></sp-loading-inprogress>
        <ng-template #loadingComplete>
          <ng-container *ngIf="basketDataLoaded && collectionData.length">
            <thehubz-collection-card-view [collectionList]="collectionData" [configObject]="configObject"> </thehubz-collection-card-view>
          </ng-container>
          <ng-container *ngIf="basketDataLoaded && !collectionData.length">
            <p i18n>No Collection selected</p>
          </ng-container>
        </ng-template>
      </div>
    </div>
  </div>
</div>
